import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faUsers,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import LotusIcon from "./LotusIcon";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer mt-auto py-3">
      <Container>
        <Row className="py-3">
          <Col md={4} className="mb-3 mb-md-0 text-center text-md-start">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start mb-3">
              <LotusIcon className="lotus-icon me-2" size={24} />
              <h5 className="mb-0">Lotus</h5>
            </div>
            <p className="small text-muted">
              Empowering collaborative note-taking and meeting management for
              student organizations.
            </p>
          </Col>
          <Col md={4} className="mb-3 mb-md-0 text-center">
            <h6 className="text-uppercase" style={{ color: "#d9669b" }}>
              Quick Links
            </h6>
            <ul className="list-unstyled mb-0">
              <li className="my-2">
                <Link to="/dashboard" className="App-link">
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                  Dashboard
                </Link>
              </li>
              <li className="my-2">
                <Link to="/meetings" className="App-link">
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                  Meetings
                </Link>
              </li>
              <li className="my-2">
                <Link to="/members" className="App-link">
                  <FontAwesomeIcon icon={faUsers} className="me-2" />
                  Members
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={4} className="text-center text-md-end">
            <h6 className="text-uppercase" style={{ color: "#d9669b" }}>
              Contact
            </h6>
            <p className="small mb-0">
              <FontAwesomeIcon icon={faEnvelope} className="me-2" />
              <a href="mailto:support@lotus.org" className="App-link">
                support@lotus.org
              </a>
            </p>
            <p className="small text-muted mt-3">
              &copy; {currentYear} Lotus. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
